import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import evkLogo from "@/assets/evk-logo.png";

const navItems = [
  { label: "Marcas", href: "#brands" }, // ✅ Sem espaços
  { label: "Clientes", href: "#clients" },
  { label: "Recrutamento", href: "#join" },
  { label: "Contactos", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Scroll effect
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // 🔒 Scroll lock no mobile
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  // Smooth scroll
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${scrolled ? "bg-white shadow-sm" : "bg-transparent"}`}>
      {/* ✅ Container responsivo que contém TODO o conteúdo */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          
          {/* Logo */}
          <a href="#hero" onClick={(e) => handleNavClick(e, "#hero")} className="flex-shrink-0">
            <img src={evkLogo} alt="EVK" className="h-7 w-auto brightness-0 dark:brightness-100" />
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a key={item.href} href={item.href} onClick={(e) => handleNavClick(e, item.href)} className="nav-link-glass">
                {item.label}
              </a>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden p-2 text-foreground hover:bg-gray-100 rounded-lg"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu + Backdrop */}
      {menuOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/20 z-40 md:hidden hidden" onClick={() => setMenuOpen(false)} aria-hidden="true" />
          
          {/* ✅ Menu com o MESMO container para alinhamento consistente */}
          <div className="fixed top-16 left-0 right-0 bg-white shadow-lg border-t z-50 md:hidden">
            <div className="container mx-auto px-4 sm:px-6 lg:px-12 py-4">
              <div className="flex flex-col gap-2">
                {navItems.map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="block py-3 px-4 rounded-lg text-foreground hover:bg-gray-50 transition-colors"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
